module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="soft-review-info">\n    <aside>\n        ' +
__e( progress.current ) +
'/' +
__e( progress.total ) +
'\n    </aside>\n    <header>\n        <h2>' +
__e( position.title ) +
'</h2>\n        <div class="soft-review-company">\n            ' +
__e( position.company_name ) +
' - ' +
__e( position.location_name ) +
'\n        </div>\n        <div class="soft-review-warning">\n            ' +
((__t = ( $.svgIcon('warning') )) == null ? '' : __t) +
'\n            <span>\n                Long commute\n            </span>\n        </div>\n    </header>\n    <section class="soft-review-content">\n        <div class="soft-review-meta-info">\n            <p>From your address, we estimate this will be about:</p>\n            <div class="soft-review-commute-time">\n                ' +
((__t = ( $.svgIcon('driving') )) == null ? '' : __t) +
'\n                <strong>~' +
__e( mismatch.driving_minutes ) +
' minutes driving</strong>\n            </div>\n            ';
 if (mismatch.transit_minutes) { ;
__p += '\n                <div class="soft-review-commute-time">\n                    ' +
((__t = ( $.svgIcon('transit') )) == null ? '' : __t) +
'\n                    <strong>~' +
__e( mismatch.transit_minutes ) +
' minutes by public transit</strong>\n                </div>\n            ';
 } ;
__p += '\n        </div>\n    </section>\n    <footer>\n        <a href="#" class="btn-confirm">Yes, I can travel there</a>\n        <a href="#" class="btn-cancel">I\'m no longer interested</a>\n    </footer>\n</div>\n';

}
return __p
}